<template>
  <v-dialog v-model="dialog" persistent width="1550px">
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card>
        <v-card-title class="headline ma-0">
          <v-icon>close</v-icon>
          {{
            [75, 77].includes(parseInt(permiso.id_estado))
              ? "Volver a estado inicial"
              : "Rechazar papeleta."
          }}
          <v-spacer></v-spacer>
          <v-btn icon @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="py-0">
          <v-container grid-list-md class="pa-0" style="min-width: 100%;">
            <v-layout row wrap>
              <v-flex xs12 class="py-0">
                <h4 class="texto">
                  <strong>Número:</strong> {{ permiso.numero }}
                </h4>
              </v-flex>
              <v-flex xs12 class="py-0">
                <h4 class="texto">
                  <strong>Nombres:</strong> {{ permiso.nombres }}
                </h4>
              </v-flex>
              <v-flex xs12 class="py-0">
                <h4 class="subtitulo-uso">
                  <strong>Detalle de vacación </strong>
                </h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  class="elevation-1 tabla-comprimida-light celda-comprimida"
                  :items="permiso_detalles"
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ props.item.fecha_desde }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.fecha_hasta }}
                    </td>

                    <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                    <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                    <td class="text-xs-center">{{ props.item.total_dias }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>

            <!--SEGUIMIENTO -->
            <v-layout row wrap>
              <v-flex xs12 class="py-0">
                <h4 class="subtitulo-uso">
                  <strong>Seguimiento de papeleta</strong>
                </h4>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                  class="elevation-1 tabla-comprimida-light celda-comprimida"
                  :items="detalle_seguimiento"
                  :headers="headers_detalle"
                  item-key="id_detalle"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ props.item.fecha_registro }}
                    </td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                    <td class="text-xs-center">{{ props.item.usuario }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-layout wrap row>
              <v-flex xs12 class="py-0">
                <h4 class="subtitulo-uso">
                  <strong>Detalles rechazo</strong>
                </h4>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  class="text-field-reducido-border"
                  v-model="form.justificacion_rechazo"
                  auto-grow
                  rows="2"
                  label="Justificación del rechazo"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                >
                </v-textarea>
              </v-flex>
              <v-flex xs12 class="text-xs-center texto">
                <b>Archivo de respaldo</b>
              </v-flex>
              <v-flex xs12 class="text-xs-center" :key="key_actualizacion">
                <div :class="this.file == '' ? 'file-empty' : 'file-upload'">
                  <v-icon large>{{
                    this.file == "" ? "file_upload" : "done"
                  }}</v-icon>
                  <br />
                  <input
                    class="input-file"
                    type="file"
                    @change="handleFileUpload()"
                    ref="file"
                    accept=".pdf"
                  />
                  <p>
                    {{
                      this.file == ""
                        ? "Arrastra y suelta cualquier archivo aquí"
                        : "El archivo se cargo exitosamente!"
                    }}
                  </p>
                  <span>
                    {{
                      this.file == ""
                        ? "o haz click aqui para buscar archivos desde el dispositivo"
                        : "Arrastra y suelta un archivo o haz click aqui para cambiar de archivo"
                    }}
                  </span>
                </div>
              </v-flex>
              <v-flex xs12 class="text-xs-center">
                <div
                  class="file-block"
                  v-if="this.file.size || adjunto.size_file"
                >
                  <v-icon>description</v-icon>
                  <div class="file-info">
                    <span>{{ this.file.name || adjunto.nombre_archivo }} </span>
                    |
                    <span>
                      {{
                        size_file_calculate(this.file.size) ||
                          size_file_calculate(adjunto.size_file)
                      }}</span
                    >
                  </div>
                  <v-icon @click="eliminaArchivo()">delete</v-icon>
                </div>
                <p
                  class="red--text body-1 ma-0"
                  v-if="errors.size"
                  :rules="$validate(['required'])"
                >
                  *Archivo demasiado grande(Mayor a 2Mb)
                </p>
                <p
                  class="red--text body-1 ma-0"
                  v-if="errors.denied"
                  :rules="$validate(['required'])"
                >
                  *Formato no admitido por el sistema, solo se acepta PDFs
                </p>
                <p
                  class="red--text body-1 ma-0"
                  v-if="errors.file"
                  :rules="$validate(['required'])"
                >
                  *No cargo un archivo adjunto
                </p>
              </v-flex>
              <v-flex
                xs12
                v-if="[75, 77].includes(parseInt(permiso.id_estado))"
              >
                <v-layout row wrap justify-center>
                  <v-flex xs12 class="text-xs-center texto">
                    <b
                      >Detalle devolución de saldos -
                      {{ total_dias_vacaciones }} día(s)</b
                    >
                  </v-flex>
                  <v-flex xs12>
                    <v-layout
                      row
                      wrap
                      v-for="(gestion, index) in l_periodo_saldo"
                      :key="index"
                    >
                      <v-flex grow>
                        <v-select
                          class="text-field-reducido-border"
                          :items="l_gestiones_vacaciones"
                          :item-value="val => parseInt(val.periodo)"
                          :item-text="
                            val =>
                              `Periodo ${val.periodo} (${val.gestion_desde}-${val.gestion_hasta}) - Dias saldo: ${val.dias_restantes}`
                          "
                          label="Periodo a devolver el saldo"
                          v-model="gestion.periodo"
                          :rules="$validate(['required'])"
                          required
                          outline
                          clearable
                        ></v-select>
                      </v-flex>
                      <v-flex grow>
                        <v-text-field
                          class="text-field-reducido-border"
                          label="Dias"
                          type="number"
                          v-model.number="gestion.dias"
                          :rules="$validate(['required'])"
                          required
                          outline
                          clearable
                        ></v-text-field>
                      </v-flex>
                      <v-flex shrink>
                        <v-tooltip bottom>
                          <v-btn
                            color="red"
                            @click.prevent="eliminarPeriodoSaldo(index)"
                            icon
                            dark
                            slot="activator"
                            ><v-icon>close</v-icon>
                          </v-btn>
                          <span>Eliminar</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex shrink>
                    <v-tooltip bottom>
                      <v-btn
                        color="primary"
                        @click.prevent="adicionarPeriodoSaldo()"
                        icon
                        slot="activator"
                        ><v-icon>add</v-icon>
                      </v-btn>
                      <span>Adicionar periodo</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.prevent="close()" :loading="loading"
            ><v-icon>check</v-icon>
            Cancelar
          </v-btn>

          <v-btn color="error" @click.prevent="apruebaRechazaPermiso(permiso)"
            ><v-icon>clear</v-icon>
            Rechazar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
//import SeguimientoDetalle from "../components/SeguimientoDetalle";

export default {
  // components: {
  //   SeguimientoDetalle,
  // },
  mixins: [validate],
  props: ["item"],
  async mounted() {
    this.$bus.$on("openDialogRechazarPermisoRRHH", async item => {
      this.permiso = item;

      await this.getDetallePermiso(this.permiso.id_vacacion);
      await this.getDetalleSeguimiemto(this.permiso.id_vacacion);
      // Cargamos gestiones
      await this.getGestionesVacaciones(this.permiso.id_persona);
      await this.getPermisoPeriodoVacacion(this.permiso.id_vacacion);

      this.dialog = true;
    });
  },
  data() {
    return {
      valid: false,
      dialog: false,
      form: {},
      permiso: {
        rechazo: ""
      },
      permiso_compensacion: [],

      permiso_detalles: [],

      detalle_seguimiento: [],
      loading: false,
      headers2: [
        {
          text: "Fecha desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers: [
        {
          text: "Fecha desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },

        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],

      headers_detalle: [
        {
          text: "Fecha registro",
          sortable: false,
          align: "center"
        },
        {
          text: "Estado",
          sortable: false,
          align: "center"
        },
        {
          text: "Usuario",
          sortable: false,
          align: "center"
        }
      ],
      l_gestiones_vacaciones: [],
      l_periodo_saldo: [{}],
      total_dias_vacaciones: 0,
      // Variables archivo adjunto
      file: "",
      errors: {
        file: true,
        size: false,
        denied: false
      },
      key_actualizacion: 1,
      adjunto: {}
    };
  },
  methods: {
    close() {
      this.dialog = false;
      this.permiso = {
        permiso: {
          motivo: ""
        }
      };
      this.form = {};
      this.file = "";
      this.errors = {
        file: true,
        size: false,
        denied: false
      };
      (this.l_periodo_saldo = [{}]), (this.key_actualizacion = 1);
      this.adjunto = {};
      this.$bus.$emit("closeDialogRechazarRRHHPapeleta");
    },
    // Metodo para adicionar periodo saldo
    adicionarPeriodoSaldo() {
      this.l_periodo_saldo.push({});
    },
    // Metodo para adicionar periodo saldo
    eliminarPeriodoSaldo(index) {
      this.l_periodo_saldo.splice(index, 1);
    },
    // Metodo para devolver tamaño de archivo
    size_file_calculate(size) {
      // if (typeof this.file == "object") {
      if (0 < size && size < 512000) {
        return `${(size / 1024).toFixed(2)}KB`;
      }
      if (512000 <= size) {
        return `${(size / (1024 * 1024)).toFixed(2)}MB`;
      }
    },
    eliminaArchivo() {
      this.file = "";
      this.key_actualizacion++;
      this.errors.file = true;
      this.errors.size = false;
      this.errors.denied = false;
    },
    // Metodo para cargar file
    handleFileUpload() {
      if (this.$refs.file.value !== "") {
        const file = this.$refs.file.files[0];
        if (this.$refs.file.files[0].size > 2048999) {
          this.errors.size = true;
        } else {
          this.errors.size = false;
        }
        if (this.$refs.file.value === "") {
          this.errors.file = true;
        } else {
          this.errors.file = false;
        }
        if (["application/pdf"].includes(this.$refs.file.files[0].type)) {
          //|| this.$refs.file.files[0].type.includes('image/')
          this.errors.denied = false;
        } else {
          this.errors.denied = true;
        }
        this.file = file;
      }
    },
    // Metodo para obtener el permiso periodo vacacion
    async getPermisoPeriodoVacacion(id_permiso) {
      try {
        let res = await this.$service.graphql({
          query: `
			    query{
            permisoPeriodoVacacions(id_permiso: ${id_permiso}){
              rows{
                id
                dias_vacaciones
              }
            }
          }
          `
        });
        let l_tmp = res.permisoPeriodoVacacions.rows;
        this.total_dias_vacaciones = l_tmp.reduce((acumulador, periodo) => {
          return acumulador + parseFloat(periodo.dias_vacaciones);
        }, 0);
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para obtener las gestiones de vacaciones
    async getGestionesVacaciones(id_persona) {
      try {
        let res = await this.$service.graphql({
          query: `
			    query{
            estadoVacacions(id_persona: ${id_persona}){
              rows{
                id
                id_estado
                id_persona
                periodo
                gestion_desde
                gestion_hasta
                dias_restantes
              }
            }
          }
          `
        });
        let l_tmp = res.estadoVacacions.rows;
        // Ordenamos la lista
        l_tmp.sort(function(a, b) {
          if (a.periodo < b.periodo) {
            return 1;
          }
          if (a.periodo > b.periodo) {
            return -1;
          }
          return 0;
        });
        this.l_gestiones_vacaciones = l_tmp;
      } catch (error) {
        console.log(error);
      }
    },
    async getDetallePermiso(id_permiso) {
      try {
        let res = await this.$service.graphql({
          query: `
			    query{
            vDetallePermisos(id_permiso: ${id_permiso}){
              rows{
                id
                id_permiso
                fecha_desde
                fecha_hasta
                hora_desde
                hora_hasta
                total_dias
                total_horas

              }
            }
          }
          `
        });
        this.permiso_detalles = res.vDetallePermisos.rows;
      } catch (error) {
        console.log(error);
      }
    },
    async getDetalleSeguimiemto(id) {
      try {
        let respuesta;
        let res;
        respuesta = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"SELECT * FROM control.v_seguimiento_detalle_historico vd where vd.id=(${id}) order by vd.id_seguimiento desc"){
                respuesta
              }
            }
          `
        });

        respuesta = respuesta.runQuery.respuesta;
        //obtener el nuevo seguimiento
        res = await this.$service.graphql({
          query: `
                query{
      			      vSeguimientoDetalles(id:${id}){
          			    rows{
                      id_detalle
						          fecha_registro
            			    estado
            			    usuario
                      jefe
                      id_estado
                      motivo
                      jefe
                      }
                  }
              }

          `
        });
        res = res.vSeguimientoDetalles.rows;
        this.detalle_seguimiento = res.concat(respuesta);
      } catch (error) {
        console.log(error);
      }
    },
    async apruebaRechazaPermiso(permiso) {
      try {
        var data_saldos = "{}";
        // Validamos que lleno todos los campos
        if (!this.$refs.form.validate()) {
          return;
        }
        if (!this.form.justificacion_rechazo) {
          return;
        }
        // Validaciones para volver a estado inicial
        if ([75, 77].includes(parseInt(this.permiso.id_estado))) {
          // Validamos que todos los campos esten completos
          for (let index = 0; index < this.l_periodo_saldo.length; index++) {
            const element = this.l_periodo_saldo[index];
            if (!element.periodo || !element.dias) {
              this.$message.info(
                "No termino de completar el detalle devolución de saldos"
              );
              return;
            }
          }
          // Validamos que el saldo que se esta devolviendo  es igual al del permiso
          if (
            this.total_dias_vacaciones !=
            this.l_periodo_saldo.reduce((acumulador, saldo) => {
              return acumulador + parseFloat(saldo.dias);
            }, 0)
          ) {
            this.$message.info(
              "Los dias a reponer no coinciden con los dias de vacacion"
            );
            return;
          }
          data_saldos = JSON.stringify(this.l_periodo_saldo).replace(
            /"/g,
            '\\"'
          );
        }
        if (!!this.file) {
          // Validamos tamano y tipo del archivo
          if (this.errors.denied) {
            return this.errors;
          }
          if (this.errors.size) {
            return this.errors;
          }
          if (this.errors.file) {
            return this.errors;
          }
        }
        this.$confirm("¿Está seguro de rechazar el permiso?", async () => {
          let ruta_archivo = "";
          // Subimos el archivo
          if (!!this.file) {
            ruta_archivo = await this.$service.uploadFile(this.file);
            // Validamo que se subio un archivo
            if (!ruta_archivo) {
              this.$alert(
                "Ocurrio un error con la subida del archivo, intentelo nuevamente por favor"
              );
              return;
            }
          }
          this.form.justificacion_rechazo = this.form.justificacion_rechazo.replace(
            /(\r\n|\n|\r)/gm,
            " "
          );
          this.form.justificacion_rechazo = this.form.justificacion_rechazo.replace(
            /"/g,
            '\\"'
          );
          const user = this.$storage.get("user");
          let respuesta = "";
          respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_rechazo_permisos_por_jefes_rrhh(${permiso.id_vacacion},${user.id},'${this.form.justificacion_rechazo}','${ruta_archivo}','${data_saldos}')"){
                respuesta
              }
            }
          `
          });

          let resp =
            respuesta.runQuery.respuesta[0].fn_rechazo_permisos_por_jefes_rrhh;
          let resps2 = resp.split("|");
          let correcto = resps2[0];
          if (correcto == "1") {
            this.$alert("El permiso fué rechazado");
            this.close();
          } else {
            this.$alert(resps2[1]);
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.titulo {
  font-size: 1.07em;
  color: rgb(0, 77, 128);
  font-weight: bold;
  margin: 0 !important;
}
.texto {
  font-size: 1.07em;
  color: rgb(0, 50, 83);
  margin: 0 !important;
}
.subtitulo-uso {
  font-size: 1.35em;
  color: rgb(0, 77, 128);
  font-weight: bolder;
  margin: 0 !important;
}
.file-empty {
  p {
    font-size: 2em;
  }
  background-color: #b2dcff6e;
  border-radius: 40px;
  border: 2px dashed #004eb4;
  color: #649de9;
  cursor: pointer;
  font-weight: bold;
  overflow: hidden;
  padding: 0.5em;
  position: relative;
  text-align: center;
  width: 100%;
  height: 100%;
  .input-file {
    cursor: pointer;
    font-size: 10000px;
    margin: 0;
    opacity: 0;
    outline: 0 none;
    padding: 0;
    position: absolute;
    right: -1000px;
    top: -1000px;
  }
}
.file-upload {
  p {
    font-size: 2em;
  }
  background-color: #b2ffd56e;
  border-radius: 40px;
  border: 2px dashed #00b469;
  color: #649de9;
  cursor: pointer;
  font-weight: bold;
  overflow: hidden;
  padding: 0.5em;
  position: relative;
  text-align: center;
  width: 100%;
  height: 100%;
  .input-file {
    cursor: pointer;
    font-size: 10000px;
    margin: 0;
    opacity: 0;
    outline: 0 none;
    padding: 0;
    position: absolute;
    right: -1000px;
    top: -1000px;
  }
}
.file-block {
  color: #f7fff7;
  background-color: #15be86;
  transition: all 1s;
  position: relative;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  border-radius: 25px;
  cursor: pointer;
  .v-icon {
    color: white;
  }
  span {
    padding: 0 3px;
  }
}
.file-info {
  display: flex;
  align-items: center;
  font-size: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/dialogs/RechazarPermisoRRHH.vue